function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1940(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 94.93,
    height: 86.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.465,
    y: 43.275,
    fontFamily: "Arial"
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.55,
    width: 94.93,
    height: 96.43,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.86625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.465,
    y: 134.765,
    fontFamily: "Arial"
  }, "\n        Greenlee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 182.98,
    width: 94.93,
    height: 99.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.821666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.465,
    y: 232.82999999999998,
    fontFamily: "Arial"
  }, "\n        Apache\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 282.68,
    width: 94.93,
    height: 110.91,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.821666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.465,
    y: 338.135,
    fontFamily: "Arial"
  }, "\n        Mohave\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.59,
    width: 94.93,
    height: 148.27,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.821666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.465,
    y: 467.72499999999997,
    fontFamily: "Arial"
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 541.86,
    width: 94.93,
    height: 158.14,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.821666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.465,
    y: 620.9300000000001,
    fontFamily: "Arial"
  }, "\n        Navajo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 0,
    width: 116.03,
    height: 139.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.50375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.945,
    y: 69.675,
    fontFamily: "Arial"
  }, "\n        Coconino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.96,
    y: 0,
    width: 141.34,
    height: 139.35,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 34.8375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.63,
    y: 69.675,
    fontFamily: "Arial"
  }, "\n        Yuma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.31,
    y: 0,
    width: 150.67,
    height: 139.35,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.869999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.645,
    y: 69.675,
    fontFamily: "Arial"
  }, "\n        Pinal\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 502.97,
    y: 0,
    width: 197.03,
    height: 139.35,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 34.8375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.485,
    y: 69.675,
    fontFamily: "Arial"
  }, "\n        Gila\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 139.35,
    width: 266.75,
    height: 125.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.982857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.305,
    y: 202.29,
    fontFamily: "Arial"
  }, "\n        Yavapai\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 265.23,
    width: 266.75,
    height: 146.3,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.900000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.305,
    y: 338.38,
    fontFamily: "Arial"
  }, "\n        Cochise\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.93,
    y: 411.53,
    width: 266.75,
    height: 288.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 66.6875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.305,
    y: 555.765,
    fontFamily: "Arial"
  }, "\n        Pima\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.69,
    y: 139.35,
    width: 338.31,
    height: 560.65,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 42.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 530.845,
    y: 419.67499999999995,
    fontFamily: "Arial"
  }, "\n        Maricopa\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1940);
export default __webpack_public_path__ + "static/media/1940.c31df2be2ac4594ab722f203a0566e51.svg";
export { ForwardRef as ReactComponent };